import { render, staticRenderFns } from "./FrzLinesPackingViews.vue?vue&type=template&id=5b9e8f63"
import script from "./FrzLinesPackingViews.vue?vue&type=script&lang=js"
export * from "./FrzLinesPackingViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports